<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { formatLineEmojiMessageForRendering } from 'shared/helpers/lineEmoji';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant, contentAttributes } = useMessageContext();

const contentWithLineEmojis = computed(() => {
  return formatLineEmojiMessageForRendering({
    text: props.content,
    contentAttributes: contentAttributes.value,
  });
});

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return contentWithLineEmojis.value;
  }

  return new MessageFormatter(contentWithLineEmojis.value).formattedMessage;
});
</script>

<template>
  <span
    v-dompurify-html="formattedContent"
    class="prose prose-bubble wlab-message-text"
  />
</template>

<style scoped>
/* Scalable font sizes for chat message text */
.wlab-message-text {
  font-size: var(--wlab-font-md) !important;
  line-height: 1.6 !important;
}

.wlab-message-text :deep(p),
.wlab-message-text :deep(span),
.wlab-message-text :deep(div) {
  font-size: inherit !important;
  line-height: inherit !important;
}

.wlab-message-text :deep(img[alt^='line-emoji-']) {
  display: inline-block;
  vertical-align: text-bottom;
  margin: 0 1px;
}
</style>
